<template>
  <div>
    <template>
      <div class="line1" v-if="showRightBtnLine1">
        <template>
          <span class="icon" v-if="couponText">{{couponText}}</span>
          <!-- <span class="btn-text" v-else>{{goodsDetail.birdRemark}}</span> -->
        </template>
        <template>
          <template v-if="firstSelectSkuVipCouponUse">
            <span class="text-price" style="margin: 0"><span class="font15">{{ isApp ? '' : '￥' }}</span>{{ realPrice[0]}}</span><span class="text-price" style="margin: 0">.{{ realPrice[1] }}</span>
          </template>
          <span class="text-price" v-else-if="goodsDetail.birdPrice"><span class="font15">{{ isApp ? '' : '￥' }}</span>{{goodsDetail.birdPrice}}</span>
          <template v-else>
            <span class="text-price" style="margin: 0"><span class="font15">{{ isApp ? '' : '￥' }}</span>{{ realPrice[0]}}</span><span class="text-price" style="margin: 0">.{{ realPrice[1] }}</span>
          </template>
        </template>

        <span class="btn-text" v-if="isApp">少年贝</span>
      </div>
      <div class="line2" v-if="showRightBtnLine1" :style=" goodsDetail.birdPrice || goodsDetail.couponUse || firstSelectSkuDiscountPrice ? line2Style : ''">
        {{ goodsDetail.birdPrice || goodsDetail.couponUse || firstSelectSkuDiscountPrice ? line2Text : '立即购买' }}
      </div>
    </template>
    <div class="line2" v-if="showLinePrice() || line2Style.textDecoration != 'line-through'" :style="line2Style">
      {{line2Text}}
    </div>

  </div>
</template>

<script>
import { env } from '@utils';

export default {
  // 专属商品按钮信息
  name: 'exclusiveBtnInfo',
  // 是否显示划线价格0: 否， 1: 是
  inject: ['showLinePrice'],
  props: {
    goodsDetail: {
      type: Object,
      default() {
        return {
          isApp: false,
        };
      }
    },
    showRightBtnLine1: {
      type: Boolean,
      default: false
    },
    firstSelectSkuDiscountPrice: Number,
    firstSelectSkuVipCouponUse: Number,
    couponText: String,
    realPrice: {
      type: Array,
      default() {
        return [];
      }
    },
    line2Style: Object,
    line2Text: String,
  },
  data() {
    return {

    };
  },
  created() {
    this.isApp = env.isApp;
  },
  computed: {
  },
  methods: {

  },
};
</script>

<style lang='stylus' scoped>
.line2
  font-size 12px
.text-price
  font-size 15px
  font-weight 500
.icon,.btn-text
  font-size 12px
  font-weight 500
</style>